export function isMobileNavDebugEnabled() {
    return process.env.NODE_ENV !== 'production'
        || window.localStorage?.getItem('debugMobileNav') === '1'
}

export function debugMobileNav(message, payload = {}) {
    if (!isMobileNavDebugEnabled()) {
        return
    }

    console.debug('[mobile-nav]', message, {
        ...payload,
        hash: window.location.hash,
        ts: Date.now(),
    })
}
